import { takeEvery, put, call } from "redux-saga/effects";

// new Password Redux States
import { SET_PASSWORD } from "./actionTypes";
import { setPasswordSuccessful, setPasswordFailed } from "./actions";
//Include Both Helper File with needed methods
import { postSetNewPwd } from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

function* setPassword({ payload: { user } }) {
  try {
    user.login = user.loginModel;
    let loginModel = user.loginModel;
    delete user.loginModel;
    const response = yield call(
      postSetNewPwd,
      constClass.REST_API_SET_PASSWORD_URL +
        `?login=${encodeURIComponent(loginModel)}`,
      user,
    );

    yield put(setPasswordSuccessful(response));
    localStorage.removeItem("setpassword");
    localStorage.removeItem("authUser");
    localStorage.setItem("isAuthProtected", false);
  } catch (error) {
    yield put(setPasswordFailed(error));
  }
}

function* pwdSaga() {
  yield takeEvery(SET_PASSWORD, setPassword);
}

export default pwdSaga;
